import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import { FormData } from '@/store/modules/FormData'
import { Routing } from '@/store/modules/Routing'
import { ErrorData } from '@/store/modules/ErrorData'
import { ConfirmationData } from '@/store/modules/ConfirmationData'
import { Auth } from '@/store/modules/Auth'
import { Basket } from '@/store/modules/Basket'
import { Orders } from '@/store/modules/Orders'

const dataState = createPersistedState(
{
    // storage:
    // {
    //     getItem: (key) => Cookies.get(key),
    //     setItem: (key, value) => Cookies.set(key, value, { expires: 1, secure: true }),
    //     removeItem: (key) => Cookies.remove(key)
    // },
    storage: window.sessionStorage,
    // Persists the full auth slice — including auth.token (the OAuth/JWT bearer
    // token returned by Nuxeo's login endpoint). Token persistence to
    // sessionStorage is intentional: it survives tab refresh but is cleared on
    // tab close. Lifetime is server-managed (Nuxeo rejects expired tokens; the
    // SPA should handle 401 by routing to login).
    paths:
    [
        'formData',
        'auth',
        'basket'
    ]
})

export default createStore(
{
    modules:
    {
        formData: FormData,
        routing: Routing,
        errors: ErrorData,
        confirmations: ConfirmationData,
        auth: Auth,
        basket: Basket,
        // In-memory "order set changed" signal (confirmed payment → header
        // badge refresh). Deliberately NOT in the persisted paths above.
        orders: Orders
    },
    plugins: [dataState]
})
